<script setup lang="ts">
import { inject } from 'vue';
import { dropdownListInjectionKey } from './internal';

const emit = defineEmits<{ select: [] }>();
const dropdown = inject(dropdownListInjectionKey, null);

function activate() {
  emit('select');
  dropdown?.close();
}

function onKeydown(e: KeyboardEvent) {
  if (e.key === 'Enter' || e.key === ' ') {
    e.preventDefault();
    activate();
  }
}
</script>

<template>
  <div class="dropdown-item" role="menuitem" tabindex="-1" @click="activate" @keydown="onKeydown">
    <slot />
  </div>
</template>

<style scoped>
.dropdown-item {
  font-family: var(--nxt-font);
  font-weight: var(--nxt-font-weight-semibold);
  font-size: var(--nxt-font-size-xs);
  line-height: 1;
  color: var(--nxt-fg);
  border-radius: var(--nxt-radius-sm);
  display: flex;
  align-items: center;
  height: var(--nxt-control-size-sm);
  padding: 0 var(--nxt-space-xs);
  user-select: none;
  cursor: pointer;
  gap: var(--nxt-space-2xs);

  &:hover,
  &:focus {
    background-color: var(--nxt-brand-subtle-bg);
    outline: none;
  }
}
</style>
